/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-17 17:57:36
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { DataTable, Button, Icon } from '@shopify/polaris';
import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { DIRECTION } from 'src/constants/synonym';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderSelect } from 'src/components/views/common/forms/render-select';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import TableHeadingCellWithTooltip from 'src/components/views/synonym/table-heading-cell-with-tooltip';
import DirectionTooltip from './direction-tooltip';
import SuggestionTooltip from './suggestion-tooltip';
import { DeleteMinor } from '@shopify/polaris-icons';

type Props = {
  field: Object
};

type ComposedProps = Props & WithI18nProps;

type State = {
  synonyms: Array<Object>
};

class SynonymsCreate extends Component<ComposedProps, State> {
  state = {
    synonyms: []
  };

  render() {
    const { i18n } = this.props;

    // Render synonyms on table
    const rowSynonyms = this.buildRows();

    return (
      <DataTable
        columnContentTypes={['text', 'text', 'text']}
        headings={[
          i18n.translate('AdminHTML.Synonym.Synonym.searchTerm'),
          <TableHeadingCellWithTooltip
            heading={i18n.translate('AdminHTML.Synonym.Synonym.direction')}
            tooltipContent={<DirectionTooltip i18n={i18n} />}
          />,
          <TableHeadingCellWithTooltip
            heading={i18n.translate('AdminHTML.Synonym.Synonym.synonyms')}
            tooltipContent={i18n.translate('AdminHTML.Synonym.Synonym.synonyms_Tooltip')}
          />,
          <TableHeadingCellWithTooltip
            heading={i18n.translate('AdminHTML.Synonym.Synonym.suggestionList')}
            tooltipContent={<SuggestionTooltip i18n={i18n} />}
          />,
          ''
        ]}
        rows={rowSynonyms}
      />
    );
  }

  // Render rows for data table
  buildRows = () => {
    const { i18n, fields } = this.props;
    const rows = fields.map((synonym, index) => {
      return [
        <Field
          name={`${synonym}.searchTerm`}
          component={RenderTextField}
          placeholder={i18n.translate('AdminHTML.Synonym.Synonym.searchTerm_Placeholder')}
        />,
        <Field name={`${synonym}.biDirection`} component={RenderSelect} options={DIRECTION} />,
        <Field
          name={`${synonym}.synonyms`}
          component={RenderTextField}
          placeholder={i18n.translate('AdminHTML.Synonym.Synonym.synonyms_Placeholder')}
        />,
        <Field name={`${synonym}.allowSuggestion`} component={RenderCheckbox} />,
        <Button
          onClick={() => {
            fields.remove(index);
          }}>
          <Icon source={DeleteMinor} />
        </Button>
      ];
    });

    return rows;
  };
}

export default withI18n()(SynonymsCreate);
